import { render, staticRenderFns } from "./storeOrderCartReturnList.vue?vue&type=template&id=24f4e8ce&scoped=true"
import script from "./storeOrderCartReturnList.vue?vue&type=script&lang=js"
export * from "./storeOrderCartReturnList.vue?vue&type=script&lang=js"
import style0 from "./storeOrderCartReturnList.vue?vue&type=style&index=0&id=24f4e8ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_a6c7c6c484daeff6636bea47b922569f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f4e8ce",
  null
  
)

export default component.exports